import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions({
      sendAbTestVariation: 'analytics/sendAbTestVariation',
      trackActiveTestsWithVariations: 'analytics/trackActiveTestsWithVariations',
      singleEvent: 'analytics/singleEvent',
    }),
    sendGTMMarkupEvent (data) {
      if (process.env.NODE_ENV === 'production') {
        this.$store.dispatch('analytics/sendStandardMarkupEvent', data, {
          global: true,
        })
      }
    },
  },
}
